import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')
import {
    resolve
} from 'url';

export default [{
    path: '/activitySession',
    component: Layout2,
    meta: {
        zhtitle: zh.m.router.common.ACTIVITY_SESSION,jatitle:ja.m.router.common.ACTIVITY_SESSION
    },
    children: [{
        path: '',
        name: 'activitySession',
        component: () => import(/* webpackChunkName: "jp.activitySession" */ '@/merchanAdmin/activitySession/list.vue'),
        meta: {
            zhtitle: zh.m.router.common.ACTIVITY_SESSION, jatitle: ja.m.router.common.ACTIVITY_SESSION, pername: "activity_setting"
        },
    }, {
        path: 'create',
        name: 'createActivitySession',
        component: () => import(/* webpackChunkName: "jp.activitySession" */ '@/merchanAdmin/activitySession/detail'),
        meta: {
            zhtitle: zh.m.router.common.CREATE, jatitle: ja.m.router.common.CREATE, pername: "activity_setting"
        },
    }, {
        path: 'detail',
        name: 'detailActivitySession',
        component: () => import(/* webpackChunkName: "jp.activitySession" */ '@/merchanAdmin/activitySession/detail'),
        meta: {
            zhtitle: zh.m.router.common.EDIT, jatitle: ja.m.router.common.EDIT, pername: "activity_setting"
        },
    }],

}]